import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ['subject', 'email', 'code', 'expiresAt', 'value', 'minimumOrderValue'];

  connect() {
    this.toggleEmailField()
  }

  toggleEmailField() {
    const shouldShowEmailField = this.subjectTarget.value == 'someone'
    this.emailTarget.classList.toggle('hidden', !shouldShowEmailField)
  }

  updateMinimumOrderValue() {
    const value = parseFloat(this.valueTarget.value) || 0
    this.minimumOrderValueTarget.value = (value * 2).toFixed(2)
  }

  generateCouponCode(event) {
    event.preventDefault()
    var result = '';
    var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
    for ( var i = 0; i < 8; i++ ) {
      result += characters.charAt(Math.floor(Math.random() * characters.length));
    }
    this.codeTarget.value = result;
  }

  resetExpiresAt(event) {
    event.preventDefault()
    this.expiresAtTarget.value = '';
  }
}
